<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Détails relatifs au paiement</legend>

        <RessourceInfoBulle code="PI-RP-1" />

        <div class="mb-2">
          <v-autocomplete
            v-model="statutEmploi.modeDeReglement"
            :item-text="itemText"
            :item-value="itemValue"
            :items="getModesDeReglement"
            :rules="rules.modeReglement"
            class="cssRequired"
            label="Mode de règlement"
            @change="modeDeReglementChange"
            required
            return-object
          ></v-autocomplete>
        </div>

        <div class="text-center mt-6 d-flex justify-space-between">
          <v-btn color="primary" @click="back()">Retour</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save()">Suivant</v-btn>
        </div>
      </fieldset>
    </v-form>
  </div>
</template>
<script>
import Loader from "../Loader"
import { mapActions, mapGetters } from "vuex"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import CatalogueLoader from "@/mixins/catalogueLoader"

// IT 10328
export default {
  mixins: [NavigationPageFormulaireMixin, CatalogueLoader],
  components: {
    Loader: Loader
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      redirectValue: "",
      valid: true,
      rules: {
        modeReglement: [(v) => (!!v && v.length != 0) || "Le mode de paiement est requis"],
        nombrePaiement: [(v) => (!!v && v.length != 0) || "Le nombre de paiement est requis"],
      }
    }
  },
  async created() {
    this.messageSelector = "Loading"
    this.overlay = true

    // Chargement catalogues suivants : Mode de règlement, Nombre de paiements
    await this.loadCatalogues([2928, 2929])

    if (this.demandeInscriptionId) {
      await this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId)
    }

    await this.recalculerMontantFacture()
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      getModesDeReglement: "Catalogue/getModesDeReglement",
      getNombreDePaiements: "Catalogue/getNombreDePaiements",
    }),
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi"
    }),
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.valid = this.$refs.form.validate()

      if (this.valid) {
        try {
          this.overlay = false
          this.next()
        } catch (err) {
          console.log(err)
        }
      }
      this.overlay = false
    },
    modeDeReglementChange() {
      this.statutEmploi.nombreDePaiements = null
      this.recalculerMontantFacture()
      this.$refs.form.resetValidation()
    },
    async recalculerMontantFacture() {
      this.overlay = true
      await this.updateStatutEmploi(this.statutEmploi)
      this.overlay = false
    }
  }
}
</script>